import { render, staticRenderFns } from "./Cargo.vue?vue&type=template&id=1558f862&"
import script from "./Cargo.vue?vue&type=script&lang=js&"
export * from "./Cargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VTreeview})
